import rems from './utils/rems';

const fontFamilies = {
  fontFamilyPrimary: '"Open Sans", "Helvetica Neue", Helvetica, Arial',
  fontFamilySecondary: 'Arial, Helvetica, sans-serif',
  fontFamilySerif: 'Georgia, "Times New Roman", Times, serif',
  fontFamilyMonospaced: '"Courier New", Courier, monospace',
};

const fontWeights = {
  fontWeightNormal: 400,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
};

const fontSizes = {
  fontSizeBase: rems(16),
  fontSizeXxl: rems(22),
  fontSizeXl: rems(20),
  fontSizeLg: rems(18),
  fontSizeMd: rems(16),
  fontSizeSm: rems(14),
  fontSizeXs: rems(12),
  fontSizeXxs: rems(10),
  fontSizeHero: rems(42),
  fontSizeH1: rems(36),
  fontSizeH2: rems(30),
  fontSizeH3: rems(24),
  fontSizeH4: rems(20),
  fontSizeH5: rems(18),
};

export default {
  ...fontFamilies,
  ...fontWeights,
  ...fontSizes,
};
